import { io, Socket } from 'socket.io-client';

import { getBearerToken } from '@/src/auth/token-storage';

const maxReconnectionAttempts = 10;

export type ContactCenterRealtimeSocket = Socket;

function apiBaseUrl() {
  return process.env.NEXT_PUBLIC_API_BASE_URL ?? 'http://localhost:3001';
}

export function createContactCenterRealtimeSocket(): ContactCenterRealtimeSocket {
  return io(apiBaseUrl(), {
    autoConnect: false,
    auth: { token: getBearerToken() },
    path: '/contact-center/socket.io',
    reconnection: true,
    reconnectionAttempts: maxReconnectionAttempts,
    reconnectionDelay: 1_000,
    reconnectionDelayMax: 30_000,
    transports: ['websocket', 'polling'],
    tryAllTransports: true,
  }) as ContactCenterRealtimeSocket;
}
